<template>
  <div>
    <button class="navbar-toggler bg-darkgrey mx-2 mt-2" type="button" data-toggle="collapse" data-target="#orderDropDown">
      <i class="fa fa-filter" />
    </button>

    <div class="collapse bg-darkgrey mx-2 " id="orderDropDown">
      <ul class="navbar-nav mx-2">
        <li>
          <div style="display: flex;">
            <button class="navbar-toggler bg-darkgrey mt-2 pl-0" type="button" data-toggle="collapse" data-target="#filterDropDown">
              <i class="fa fa-search" />
            </button>
          </div>
          <div class="collapse bg-darkgrey" id="filterDropDown">
            <ul class="navbar-nav mx-2">
              <regular-select
                :value="searchType"
                @change="searchType = $event"
                :placeholder="$t('Zone.searchType')">
                  <option v-for="(field, index) in fields" :key="index" :value="field.type">{{field.mobileText || field.text}}</option>
              </regular-select>

              <regular-input v-if="searchType === 'creationDate'" type="date" class="mt-2" :placeholder="$t('Search.title')" :value="searchText" v-model="searchText"/>

              <regular-select
                v-if="searchType === 'status'"
                :value="searchText"
                @change="searchText = $event"
                :placeholder="$t('OrderCurrent.searchSelection')" class="mt-2 form-group">
                <option v-for="status in statusMap" :key="status.text" :value="$t(`Search.status.${status.text}`)">{{$t(`Search.status.${status.text}`)}}</option>
              </regular-select>

              <regular-input v-if="searchType != 'status' && searchType != 'creationDate'" class="mt-2" :placeholder="$t('Search.title')" :value="searchText" v-model="searchText"/>

              <div v-for="(searchedItem, index) in searchHistory" :key="index">
                <h6>{{searchedItem.historyTypeTag}}: {{searchedItem.searchText}} <i class="fa fa-times-circle" @click="removeSearchedItem(index, searchedItem.searchType)" /></h6>
              </div>

              <button class="btn btn-kne-orange my-2" @click="evaluateFiltering(searchType, searchText)" :disabled="this.searchType === '' || this.searchText === ''" >
                {{$t('Search.submit')}}
              </button>

            </ul>
          </div>
        </li>
        <li v-for="field in fields" :key="field.type">
          <p @click="$emit('sortBySearchFilter', field.type, false)" class="mt-2"><i class="fa mr-1" :class="field.icon" />{{field.mobileText || field.text}}<i v-if="sort.current === field.type" class="ml-2 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true" /></p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import regularInput from '../basic-components/regularInput.vue'
import RegularSelect from '../basic-components/regularSelect.vue'
/** Component for mobile search/filter */

export default {
  name: 'SearchFilter',
  components: {
    regularInput,
    RegularSelect
  },
  props: {
    fields: {
      required: true,
      type: Array
    },
    sort: {
      required: true,
      type: Object
    }
  },

  data () {
    return {
      searchHistory: [],
      searchType: '',
      searchText: '',
      historyTypeTag: '',
      statusMap: {
        processing: {
          text: 'processing'
        },
        dispatch: {
          text: 'dispatch'
        },
        pick: {
          text: 'pick'
        },
        transit: {
          text: 'transit'
        },
        drop: {
          text: 'drop'
        },
        finished: {
          text: 'finished'
        },
        transfered: {
          text: 'transfered'
        },
        rejected: {
          text: 'rejected'
        },
        inspection: {
          text: 'inspection'
        },
        waiting: {
          text: 'waiting'
        }
      }
    }
  },

  methods: {
    /** Whenever changes/updates are made to the list of orders, this function is called to perform the necessary filtering/ordering
     * @param attr (String) - The filtered field
     * @param val (String) - The value that was entered in the field
    */
    evaluateFiltering (attr, val) {
      // If there are any filter searches
      this.fields.forEach((element, index) => {
        if (element.type === attr) this.fields[index].value = val
      })

      this.$emit('callFilteredSearchMethod', this.fields)
      var isAttrDupe = false

      if (val === '') return

      // Search history for mobile
      this.searchHistory.find((o, i) => {
        if (o.searchType === attr) {
          var storedDupeTag = this.setSearchedItemTag(attr) // To make sure there are no duplicate search tags
          this.searchHistory[i] = {searchType: attr, searchText: val, historyTypeTag: storedDupeTag}
          isAttrDupe = true
          return
        }
      })

      if (!isAttrDupe) this.addSearchedItem(attr, val)
    },

    setSearchedItemTag (attr) {
      var storedTag
      if (attr === '.key') { storedTag = this.$t('OrderCurrent.order') }
      if (attr === 'creationDate') { storedTag = this.$t('OrderCurrent.date') }
      if (attr === 'status') { storedTag = this.$t('OrderCurrent.status') }
      if (attr === 'driverName') { storedTag = this.$t('OrderCurrent.driver') }
      if (attr === 'numRef') { storedTag = this.$t('OrderCurrent.reference') }
      if (attr === 'source') { storedTag = this.$t('OrderCurrent.source') }
      if (attr === 'vin') { storedTag = this.$t('OrderCurrent.VIN') }
      if (attr === 'transmitterName') { storedTag = this.$t('OrderCurrent.pickup') }
      if (attr === 'receiverName') { storedTag = this.$t('OrderCurrent.delivery') }
      if (attr === 'payerName') { storedTag = this.$t('OrderCurrent.billing') }
      return storedTag
    },

    /**
     * @param searchedType (String) - Which search field was used (Order, creation date, etc.)
     * @param searchedText (String) - What was entered in the input field
     */
    addSearchedItem (searchedType, searchedText) {
      var storedTag = this.setSearchedItemTag(searchedType)
      this.searchHistory.push({searchType: searchedType, searchText: searchedText, historyTypeTag: storedTag}) // HistoryTypeTag is used for duplicate type searches
    },

    removeSearchedItem (index, attr) {
      this.searchHistory.splice(index, 1)
      this.evaluateFiltering(attr, '')
    }
  }

}
</script>

<style>

</style>
